import { Button, Group, Select, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DEFAULT_NGP_CAMPAIGN_YEARS,
  GpSurfacesMapClause,
} from '../../../lib/types/gp-surfaces-map';

const CLAUSE_OPTIONS: GpSurfacesMapClause[] = ['gp', 'new'];

type GpSurfacesMapClauseControlsProps = {
  clause: GpSurfacesMapClause;
  campaignYear: number;
  availableCampaignYears?: readonly number[];
  onClauseChange: (clause: GpSurfacesMapClause) => void;
  onCampaignYearChange: (year: number) => void;
};

export const GpSurfacesMapClauseControls: FC<
  GpSurfacesMapClauseControlsProps
> = ({
  clause,
  campaignYear,
  availableCampaignYears = DEFAULT_NGP_CAMPAIGN_YEARS,
  onClauseChange,
  onCampaignYearChange,
}) => {
  const { t } = useTranslation();

  const yearOptions = availableCampaignYears.map((year) => ({
    value: String(year),
    label: String(year),
  }));

  return (
    <Group align="center" gap="md" wrap="wrap">
      <Group
        aria-label={t('sampling.results.clause.group_label')}
        gap="xs"
        role="radiogroup"
        wrap="wrap"
      >
        {CLAUSE_OPTIONS.map((option) => {
          const active = clause === option;

          return (
            <Button
              aria-checked={active}
              key={option}
              onClick={() => onClauseChange(option)}
              role="radio"
              type="button"
              variant={active ? 'filled' : 'default'}
            >
              {t(`clauses.${option}`)}
              <Text
                c={active ? undefined : 'dimmed'}
                component="span"
                fw={500}
                ml="xs"
                size="xs"
              >
                {t(`sampling.results.clause.${option}_case`)}
              </Text>
            </Button>
          );
        })}
      </Group>
      {clause === 'new' ? (
        <Select
          allowDeselect={false}
          data={yearOptions}
          onChange={(value) => {
            if (value) {
              onCampaignYearChange(Number(value));
            }
          }}
          value={String(campaignYear)}
          w={120}
        />
      ) : null}
    </Group>
  );
};
